import React from "react";
import HeroImg from "./assets/images/hero-appointment.png";
// import Consult from "./components/Consult";
// import Testimonials from "./components/Testimonials";
import Whatsapp from "./assets/icons/whatsapp.png";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
AOS.init();

const BookAppointment = () => {
  return (
    <div>
      {/* hero-section */}
      <section
        style={{ backgroundImage: `url(${HeroImg})` }}
        className="w-full h-[60vh] md:h-[70vh] lg:h-[100vh] relative  flex items-start justify-center flex-col gap-3 bg-center bg-cover"
      >
        {/* <div className="bg-gradient-to-r md:h-[70vh] lg:h-[100vh] from-[#1C022180]/100 to-[#1C022180]/50 h-[80vh] w-full absolute top-0"></div> */}
        <div
          data-aos="fade-in"
          data-aos-delay="0"
          data-aos-duration="1000"
          className="z-10 lg:px-24 md:px-10 px-4 "
        >
          <div className="lg:w-[75%] md:w-[85%] text-white flex flex-col gap-4">
            <h1 className="md:text-5xl  text-3xl text-white font-semibold md:leading-[3.5rem]">
              Book Your Appointment Today!
            </h1>
            <p className="md:text-lg text-base lg:text-base md:w-[70%] lg:w-full">
              Schedule a diagnostic test with ease! Book your appointment online
              today.
            </p>
          </div>
        </div>
      </section>
      {/* <Consult /> */}
      <div className="w-full flex justify-center items-center lg:px-24 md:px-10 md:mx-0 py-7">
        <div>
          <a href="https://wa.link/qsabnq">
            <div className="bg-[#25D366] text-white px-7 py-3 rounded-[25px] flex items-center gap-3 w-[13rem] ">
              <img src={Whatsapp} className="w-[1.2rem]" alt="" />
              <p>Send a message</p>
            </div>
          </a>
        </div>
      </div>
      {/* <Testimonials /> */}
    </div>
  );
};

export default BookAppointment;
